/** Leaflet 1.9.4 from unpkg with SRI, loaded once on demand (the /districts/ index pins the same build in its HTML). */
declare const L: any;

const LEAFLET_JS = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
const LEAFLET_JS_SRI = 'sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo=';
const LEAFLET_CSS = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
const LEAFLET_CSS_SRI = 'sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY=';

let loading: Promise<void> | null = null;

export function loadLeaflet(): Promise<void> {
  if (typeof L !== 'undefined') return Promise.resolve();
  if (loading) return loading;
  const css = document.createElement('link');
  Object.assign(css, { rel: 'stylesheet', href: LEAFLET_CSS, integrity: LEAFLET_CSS_SRI, crossOrigin: '' });
  document.head.appendChild(css);
  loading = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    Object.assign(script, { src: LEAFLET_JS, integrity: LEAFLET_JS_SRI, crossOrigin: '' });
    script.onload = () => resolve();
    script.onerror = () => { loading = null; reject(new Error('Leaflet unavailable')); };
    document.head.appendChild(script);
  });
  return loading;
}

/** Longitudes east of the antimeridian (the Aleutians) brought west, so Alaska shapes stay in one piece on the map. */
export function westernHemisphere(geojson: any): any {
  const shift = (c: any): any => (typeof c[0] === 'number' ? [c[0] > 0 ? c[0] - 360 : c[0], ...c.slice(1)] : c.map(shift));
  const geometry = (g: any) => (g && g.coordinates ? { ...g, coordinates: shift(g.coordinates) } : g);
  if (geojson?.type === 'FeatureCollection') return { ...geojson, features: geojson.features.map((f: any) => ({ ...f, geometry: geometry(f.geometry) })) };
  if (geojson?.type === 'Feature') return { ...geojson, geometry: geometry(geojson.geometry) };
  return geometry(geojson);
}
